import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { ReactNode, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface CreateTermineDrawerWrapperProps {
  onClose: () => void;
  children: ReactNode;
}

export function CreateTermineDrawerWrapper({
  onClose,
  children,
}: CreateTermineDrawerWrapperProps) {
  const { t } = useTranslation();

  return (
    <Drawer open onOpenChange={onClose}>
      <DrawerContent
        className={cn(
          'fixed inset-0 h-screen w-screen max-h-none rounded-none',
          'data-[vaul-drawer-direction=bottom]:mt-0',
          'data-[vaul-drawer-direction=bottom]:max-h-none',
          'data-[vaul-drawer-direction=bottom]:rounded-none',
          'data-[vaul-drawer-direction=bottom]:border-0',
        )}>
        <Suspense
          fallback={
            <>
              <DrawerHeader className="bg-neutrals-N200 ">
                <DrawerTitle className="flex items-center justify-between">
                  <DrawerClose className="flex items-center gap-2"></DrawerClose>
                </DrawerTitle>
              </DrawerHeader>
              <div className="flex flex-col h-screen gap-4 items-center justify-center text-sm">
                <FontAwesomeIcon
                  icon={faSpinnerThird}
                  className="text-primary-blue-B200"
                  spin
                  size="4x"
                />
                {t('actions.loading')}
              </div>
            </>
          }>
          {children}
        </Suspense>
      </DrawerContent>
    </Drawer>
  );
}
